import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop error — it's a browser quirk, not a real bug
const resizeObserverErr = (e) => {
  if (e.message?.includes?.('ResizeObserver loop') || e.reason?.message?.includes?.('ResizeObserver loop')) {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErrStyle = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErrDiv) resizeObserverErrDiv.remove();
    if (resizeObserverErrStyle) resizeObserverErrStyle.remove();
    e.stopImmediatePropagation?.();
    e.preventDefault?.();
    return true;
  }
};
window.addEventListener('error', resizeObserverErr);
window.addEventListener('unhandledrejection', resizeObserverErr);
const _origConsoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) return;
  _origConsoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Report Web Vitals to GA4
import('./utils/webVitals').then(({ reportWebVitals }) => reportWebVitals());

// Register Service Worker with update detection
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => {
        // Check for updates every 30 minutes
        setInterval(() => reg.update(), 30 * 60 * 1000);
      })
      .catch(() => {});
  });
}
